import { func, object } from 'prop-types'
import { Button } from '@opallabs/kuiper'
import { buildMenu } from './helpers'

const popoverOptions = {
  hasCaret: true,
}

const PhaseContextualMenu = ({ onContextMenuAction, phase }) => (
  <Button
    aria-hidden={true}
    closeOnSelect={true}
    icon="gem-settings"
    iconOptions={{ system: 'gem' }}
    noArrow={true}
    onSelect={onContextMenuAction}
    options={buildMenu(phase)}
    popoverOptions={popoverOptions}
    tabIndex={-1}
    type="invisible"
  />
)

PhaseContextualMenu.propTypes = {
  onContextMenuAction: func.isRequired,
  phase: object.isRequired,
}

export default PhaseContextualMenu
